import React, {Component} from 'react';
import { UserResultRow } from "./UserResultRow";
import { UserResultRowList } from "./UserResultRowList";
import { Link } from "react-router-dom";
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import TagColumns from "./TagColumns";
import ProjectResultsFilter from "../common/filter/ProjectResultsFilter";

type State = {
    list: UserResultRowList,
    tags: string[],
    onlyStationary: boolean,
    onlyOther: boolean
}

export default class ProjectResultListPage extends Component<ServiceCollectionParam, State> {

    state: State = {
        list: new UserResultRowList([]),
        tags: [],
        onlyStationary: false,
        onlyOther: false
    }

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        const filter = new ProjectResultsFilter().readFromRaw(this.state);

        const resultList = await this.props.services.dao.getProjectResults(filter)
            .then(results => new UserResultRowList(
                results.map(each => new UserResultRow(each))));

        this.state.list = resultList;

        const maxTagCount = Math.min(resultList.getTags().length, 10);
        this.state.tags = resultList.getTags().slice(0, maxTagCount);
        // const maxTagCount = resultList.getTags().length;
        // this.state.tags = resultList.getTags().slice(5, maxTagCount);

        this.setState(this.state);
    }

    async toggleOnlyStationary() {
        this.state.onlyStationary = !this.state.onlyStationary;

        await this.loadData();
    }

    async toggleOnlyOther() {
        this.state.onlyOther = !this.state.onlyOther;

        await this.loadData();
    }

    render() {
        let rowNr = 1;

        const repoName = this.props.services.uiSettings.repoName;

        return (
            <>
                <table className="table table-sm">
                    <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col"><a href="#">Nimi<i className="material-icons">keyboard_arrow_up</i></a></th>
                        <th scope="col">Kasutaja</th>
                        {this.state.tags.map((tag, i) => <td key={i}>{tag}</td>)}
                        <th scope="col">Kokku</th>
                        <th scope="col">Hi</th>
                        <th scope="col">Üv</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.list.rows.map(row => (
                        <tr key={rowNr}
                            className={row.hasCodeMatchProblem() ? 'table-danger' : ''}>
                            <td>{rowNr++}</td>
                            <td className="no-wrap">
                                <Link to={`/results/${row.userName}`}>{row.name}</Link>
                            </td>
                            <td>
                                <a target='_blank'
                                   href={`https://github.com/${row.userName}/${repoName}/`}>{row.userName}</a>
                            </td>
                            <TagColumns row={row} tagList={this.state.tags}/>
                            <td>
                                <Link to={`/reviews/${row.userName}`}>{row.score}</Link>
                            </td>
                            <td>
                                {row.latePenalties}
                            </td>
                            <td>
                                {row.reviewPoints}
                            </td>
                        </tr>))
                    }

                    </tbody>
                </table>

                <label>
                    <input type="checkbox"
                           onChange={() => this.toggleOnlyStationary()}/>
                    &nbsp;Ainult statsionaarõpe&nbsp;
                </label>

                <label>
                    <input type="checkbox"
                           onChange={() => this.toggleOnlyOther()}/>
                    &nbsp;Ainult teised&nbsp;
                </label>

                <br/><br/>

                <table className="table table-sm">
                    <thead>
                    <tr>
                        <th scope="col">Tag</th>
                        <th scope="col">Count</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.list.getPassCounts().map(row => (
                        <tr key={row.tag}>
                            <td>{row.tag}</td>
                            <td>{row.count}</td>
                        </tr>))
                    }
                    </tbody>
                </table>
            </>);
    }

}
